import { Button, useTheme } from '@mui/material';

export const CloseButton = ({ ...props }) => {
  const theme = useTheme();

  const { primary, text1 } = theme;
  return (
    <Button
      {...props}
      sx={{
        bgcolor: primary || '#000',
        color: text1 || '#FFF',
        transition: 'background-color 0.3s, color 0.3s',
        '&:hover': {
          bgcolor: primary || '#000',
          color: text1 || '#FFF',
        },
      }}
    />
  );
};
